import React from "react";

/**
 * @component CollapseAllIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CollapseAllIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CollapseAllIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CollapseAllIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 15l4.72 4.461a.867.867 0 010 1.275.993.993 0 01-1.348 0L12 17.549l-3.372 3.187a.993.993 0 01-1.349 0 .867.867 0 010-1.275L12 15zm4.72-11.736a.867.867 0 010 1.275L12 9 7.28 4.539a.867.867 0 010-1.275.993.993 0 011.348 0L12 6.451l3.372-3.187a.993.993 0 011.349 0zM12 14a2 2 0 100-4 2 2 0 000 4z"
        fillRule="nonzero"
      />
    </svg>
  )
);
CollapseAllIcon.displayName = "CollapseAllIcon";
export default CollapseAllIcon;
